var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconKing = function SvgIconKing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M5.3 15.465c0 .158.126.287.287.287h8.829c.158 0 .287-.13.287-.287v-1.05H5.3v1.05ZM17.058 6.26a.293.293 0 0 0-.345.01l-3.797 3.02-2.665-4.909c-.098-.187-.402-.184-.503 0L7.083 9.29 3.286 6.271a.285.285 0 0 0-.341-.012.288.288 0 0 0-.112.325l2.358 7.255h9.62l2.356-7.255a.29.29 0 0 0-.11-.325Z"
  })));
};
export default SvgIconKing;